import { useSelector } from 'react-redux'
import { selectRobot } from 'store/selectors/robot'

import ServiceReportRow from './ServiceReportRow'

import style from './Service.module.css'

/** Gausium Service tab: service report only (no Autonomics maintenance/deployment controls). */
const GausiumServiceControl = () => {
  const robot = useSelector(selectRobot)

  return (
    <div className={style.root}>
      <ServiceReportRow
        serialNumber={robot.robotInfo?.serialNumber}
        robotType={robot.robotInfo?.robot_type}
        robotTypeDisplay={robot.robotInfo?.robot_type_display}
        vendor={robot.robotInfo?.vendor}
      />
    </div>
  )
}

export default GausiumServiceControl
